module.exports = __webpack_public_path__ + "static/media/HeavensHalberd.7f711c85.png";